import Drawer from '@mui/material/Drawer';
import { useState, useEffect } from 'react';
import { getOne } from '../BackendProvider';
import React from 'react';
const DrawerPane = (props) => {

    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (props.id !== undefined && props.id !== null) {
            setLoading(true);
            getOne(props.url, props.id).then(
                response => {
                    setData(response.data.data);
                    setLoading(false);
                }
            );
        }
    }, [props.url, props.id]);
    return (
        <Drawer anchor="right" open={props.open} onClose={props.onClose}
            PaperProps={{
                sx: { maxWidth: "90%" },
            }}>
            {props.children ? React.cloneElement(props.children, { data: data, loading: loading }) : null}
        </Drawer>
    )
}

export default DrawerPane;